// import { ContactMap } from 'ContactMap'; // Adjust the path accordingly
import React from "react";
import { Popup, MapContainer, TileLayer, Marker } from "react-leaflet";
import { LeafletMap } from "./ContactMap";
const position = [39.15803, -76.68002];
const zoom = 17;
export default function Contact() {
  return (
    <>
      <div className={"content-wrapper"}>
        <div className={"content"}>
          <h1>Contact Us</h1>

          <div style={{ display: "flex" }}>
            <div style={{ flex: "1" }}>
              <p
                style={{
                  verticalAlign: "text-top",
                  fontSize: "18px",
                }}
                className={"start-head"}
              >
                CTI welcome's your questions, comments, and concerns. A sales or
                customer service representative will be in touch within the next
                24 hours. If you have an immediate question, please call us
                within our operating hours toll free or send us an email. We
                look forward to working with you!
                <br />
                <br />
                <span style={{ fontSize: "smaller" }}>
                  <b>Address</b>: 7509 Connelly Drive, Suite C, Hanover, MD
                  21076
                  <a
                    href="
https://www.google.com/maps/dir/?api=1&destination=Contrax Technologies Inc, 7509 Connelley Dr # C, Hanover, MD 21076

                  "
                  >
                    <br />
                    [Get Directions]
                  </a>
                  <br />
                  <b>Phone</b>: <a href={`tel:4107606611`}>(410) 760-6611</a>
                  <br />
                  <b>Email</b>:{" "}
                  <a href={"mailto:c_contrax@mindspring.com"}>
                    c_contrax@mindspring.com
                  </a>
                </span>
              </p>
            </div>

            <div style={{ width: "50%", height: "400px", padding: "0 50px" }}>
              <MapContainer
                center={position}
                zoom={zoom}
                minZoom={zoom}
                maxZoom={zoom}
                scrollWheelZoom={false}
                maxBounds={[position, position]}
                zoomControl={false}
                attributionControl={false}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "5px 30px",
                }}
              >
                <TileLayer
                  attribution="&copy; Google contributors"
                  url="http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
                <Marker
                  position={position}
                  radius={20}
                  color="red"
                  fillOpacity={0.5}
                >
                  <Popup>
                    <a
                      href={`https://www.google.com/maps/dir/?api=1&destination=Contrax Technologies Inc, 7509 Connelley Dr # C, Hanover, MD 21076`}
                    >
                      Get Directions
                    </a>
                  </Popup>
                </Marker>

                <div
                  className="leaflet-bottom leaflet-center"
                  style={{
                    fontSize: "small",
                    background: "white",
                    padding: "10px",
                    opacity: "80%",
                  }}
                >
                  Contrax Technologies, Inc. (Hanover, MD)
                </div>
              </MapContainer>
            </div>
          </div>

          {/* Possibly implement form input here */}
        </div>
      </div>

      <div className={"bg-img"}>
        <img src="./Scripts/Assets/contrax_logo.svg" alt="" class="logo" />
      </div>
    </>
  );
}
